import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { config } from 'utils/apiEndPoint';

function persistTokensFromPayload(data) {
    if (!data?.access) return;
    localStorage.setItem('access-token', data.access);
    if (data.refresh) localStorage.setItem('refresh-token', data.refresh);
    localStorage.setItem('accessToken', data.access);
}

export async function logIn(payload) {
    try {
        const response = await axios.post(`${config?.authentication?.signIn}`, payload);
        persistTokensFromPayload(response?.data);
        return response;

    } catch (e) {
        console.error('Error in signIn API:', e);
        throw e;
    }
}

/** Send OTP to admin email. Returns axios response; body should include token for verify step. */
export async function sendLoginOtp(email) {
    return axios.post(config.authentication.loginWithOtp, { email });
}

/** Verify OTP and receive JWT (same shape as password login when successful). */
export async function verifyLoginOtp({ token, otp }) {
    const response = await axios.post(config.authentication.loginVerifyOtp, {
        token,
        otp: String(otp).trim(),
    });
    persistTokensFromPayload(response?.data);
    return response;
}      
export async function createNewUser(payload) {
    try {
        const response  = await axios.post(`${config?.authentication?.signUp}`, payload)
        console.log(response, 'checking the response')
        // return response
    }  catch(e) {
        console.log(e)
    }
}

// Function to get the current user
export function getCurrentUser() {
    try {
        const token = localStorage.getItem('token');
        return jwtDecode(token);
    } catch (error) {
        return null;
    }
};
